import * as api from 'helpers/api';
import { renameProp } from 'helpers/object_helpers';
import { NEW_PHOTO_ATTACHMENT_ID_PREFIX } from '../../helpers/photos/constants';

const transformSurveyPropertyData = (data) => {
  if (!data.photoAttachmentsAttributes) return data;

  const photoAttachmentsAttributes = data.photoAttachmentsAttributes.map((photoAttachment) => {
    if (photoAttachment.copy) {
      return renameProp('deleted', '_destroy', { ...photoAttachment });
    }
    const photoAttributes = {
      attachmentType: photoAttachment.attachmentType,
      id: photoAttachment.photoId,
      uploadId: photoAttachment.uploadId
    };
    const transformed = { ...photoAttachment, photoAttributes };

    const hasToDeleteId = transformed.id &&
                          typeof transformed.id === 'string' &&
                          transformed.id.startsWith(NEW_PHOTO_ATTACHMENT_ID_PREFIX);
    if (hasToDeleteId) delete transformed.id;
    delete transformed.uploadId;
    delete transformed.attachmentType;
    delete transformed.photoId;

    return renameProp('deleted', '_destroy', transformed);
  });

  return { ...data, photoAttachmentsAttributes };
};

export function createSurveyProperty(path, surveyProperty, leaseSpaceData) {
  const params = { surveyProperty: transformSurveyPropertyData(surveyProperty) };
  if (leaseSpaceData) {
    params.surveyPropertyType = 'lease';
    params.surveyProperty.leaseDetailsAttributes = leaseSpaceData;
  } else {
    params.surveyPropertyType = 'buy';
  }

  return api.post(path, params);
}

export function updateSurveyProperty(path, surveyPropertyData, leaseDetailsAttributes) {
  const surveyProperty = { ...transformSurveyPropertyData(surveyPropertyData), leaseDetailsAttributes };

  return api.put(path, { surveyProperty });
}

export function deleteSurveyProperty(assignmentId, propertyId) {
  return api.deleteRequest(`/assignments/${assignmentId}/survey_properties/${propertyId}`);
}
